export const SUBSCRIPTION_TYPES = {
    SUBSCRIPTION: 'products.subscription',
    PAY_PER_VIEW: 'products.pay.per.view'
}

export const PRODUCT_RECURRING_PERIOD = 'MONTHLY';
export const PRODUCT_RECURRING_TYPE = 'RECURRING';